import { render } from "./TemplateDescription.vue?vue&type=template&id=36845180&scoped=true"
import script from "./TemplateDescription.vue?vue&type=script&lang=js"
export * from "./TemplateDescription.vue?vue&type=script&lang=js"

import "./TemplateDescription.vue?vue&type=style&index=0&id=36845180&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36845180"]])

export default __exports__